<div class="print-controls noPrint">
  <button id="print-button" class="print-btn no-print" (click)="printPageA4Portrait()">Print</button>
  <button class="close-btn" mat-dialog-close>Close</button>
</div>

<div class="press-release-container" id="print-section">
  <div class="header">
    <div class="header-title">प्रसिद्धी पत्रक</div>
    <div class="header-info">
      <span>अंक नाव :- {{ issuenamenew }}</span>
      <span>अंक दिनांक :- {{ issuedatepp | date : 'dd-MM-yyyy' }}</span>
      <span>दिनांक :- {{ currentDate | date: 'dd-MM-yyyy' }}</span>
      <span style="text-align: left; padding-left: 15px;">प्रतिनिधी नाव :- {{ rep_name }}</span>
    </div>
  </div>

  <div class="divider"></div>
  
  <table class="address-table" border="1" cellspacing="0" cellpadding="8">
    <thead>
      <tr>
        <th colspan="5" style="text-align: center; padding: 12px; font-size: 18px;">पत्ता यादी</th>
      </tr>
      <tr>
        <th>जहिरातदार नाव</th>
        <th>ठिकान</th>
        <th>संपर्क क्रमांक</th>
        <th>जाहिरात रक्कम</th>
        <th>जमा रक्कम</th>
        <th>येणे बाकी</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let advtGroup of Address">
        <tr *ngFor="let data of advtGroup">
          <td><strong>{{ data.name | slice : 0:30 }}</strong></td>
          <td>{{ data.taluka }}, {{ data.district }}, {{ data.state }}</td>
          <td><strong>{{ data.mobile }}</strong></td>
          <td style="text-align: end;">{{ data.advt_amt || 0 }}</td>
          <td style="text-align: end;">{{ data.rcv_amt || 0 }}</td>
          <td style="text-align: end;font-weight: bold;">{{ data.remaining_amt  || 0}}</td>

        </tr>
      </ng-container>
    </tbody>
  </table>
</div>